// React conversion with MUI Table + GridContainer/GridItem
import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/CustomButton";

import PrintIcon from "@material-ui/icons/PictureAsPdf";
import TableRowsIcon from "@material-ui/icons/TableChart";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import Typography from "@material-ui/core/Typography";

export default function ReportLegacy({
  infos,
  forma,
  title,
  timezones,
  report_tz,
  onGeneratePdf,
  onGenerateCsv,
  onBack,
  formatNumber,
}) {
  const agency = infos.agency;
  const details = infos.details;

  return (
    <GridContainer style={{ padding: 20 }}>
      {/* ---------------- TOP HEADER ---------------- */}
      <GridItem xs={12}>
        <GridContainer style={{ marginBottom: 16 }}>
          <GridItem xs={12} sm={12} md={6}>
            <Typography variant="h6">
              {report_tz &&
                `${timezones[report_tz]} - ${report_tz.toUpperCase()}`}
            </Typography>
            <Typography variant="h5">{title}</Typography>
          </GridItem>

          <GridItem xs={12} sm={12} md={6}>
            <GridContainer>
              <GridItem xs={12} sm={4}>
                <Button
                  type="submit"
                  variant="green"
                  startIcon={<PrintIcon />}
                  onClick={() => onGeneratePdf(5, "pdf")}
                  sx={{ ml: 2 }}
                >
                  PDF
                </Button>
              </GridItem>

              <GridItem xs={12} sm={4}>
                <Button
                  type="submit"
                  variant="green"
                  startIcon={<TableRowsIcon />}
                  onClick={() => onGenerateCsv(5, "csv")}
                  sx={{ ml: 2 }}
                >
                  CSV
                </Button>
              </GridItem>

              <GridItem xs={12} sm={4}>
                <Button
                  type="submit"
                  color="success"
                  style={{
                    backgroundColor: "#FFF",
                    borderColor: "#13816F",
                    color: "#13816F",
                    border: "1px solid",
                    width: "100%",
                  }}
                  startIcon={<ArrowBackIcon />}
                  onClick={onBack}
                >
                  Back To Reports
                </Button>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </GridItem>

      {/* ---------------- DATE + COMPANY ---------------- */}
      <GridItem xs={12} style={{ marginTop: 10 }}>
        <GridContainer>
          <GridItem xs={12} sm={2}>
            Date: {new Date().toLocaleString()}
          </GridItem>

          <GridItem
            xs={12}
            sm={10}
            style={{ textAlign: "right", fontSize: 20, marginTop: -10 }}
          >
            HDI Seguros, S.A. de C.V.
          </GridItem>
        </GridContainer>
      </GridItem>

      {/* ---------------- TABLE ---------------- */}
      <GridItem xs={12}>
        <TableContainer component={Paper}>
          <Table>
            {/* ---------- HEADER GLOBAL ---------- */}
            <TableHead>
              <TableRow>
                <TableCell
                  colSpan={9}
                  style={{ background: "#13816F", color: "#fff", fontSize: 16 }}
                >
                  {agency.code} {agency.name}
                </TableCell>
              </TableRow>
            </TableHead>

            {/* ---------- BODY GLOBAL (ÚNICO) ---------- */}
            <TableBody>
              {Object.entries(details).map(([date, methods]) => {
                let totals = {};

                return (
                  <React.Fragment key={date}>
                    {/* ---- FECHA ---- */}
                    <TableRow>
                      <TableCell colSpan={9} style={{ background: "#F1FCF9" }}>
                        Issue Date: {new Date(date).toLocaleDateString()}
                      </TableCell>
                    </TableRow>

                    {/* ---- MÉTODOS (Cash, Credit Card, etc.) ---- */}
                    {Object.entries(methods).map(([methodName, rows]) => {
                      let subtotal = {
                        net: 0,
                        policy: 0,
                        iva: 0,
                        total: 0,
                        agency: 0,
                        collected: 0,
                      };

                      return (
                        <React.Fragment key={methodName}>
                          {/* ----- HEADER DEL GRUPO ----- */}
                          <TableRow style={{ background: "#CFF0EA" }}>
                            {[
                              "Policy Number",
                              "Customer Name",
                              "Net Premium",
                              "Policy Fee",
                              "IVA",
                              "Total Premium",
                              "Agency Fee",
                              "Total Collected",
                              "Payment Type",
                            ].map((h) => (
                              <TableCell key={h} style={{ fontWeight: 600 }}>
                                {h}
                              </TableCell>
                            ))}
                          </TableRow>

                          {/* ----- ROWS DEL GRUPO ----- */}
                          {rows.map((row, idx) => {
                            const key = row.payment_type_name;

                            methodName = row.payment_type_name;

                            if (!totals[key]) {
                              totals[key] = {
                                net: 0,
                                policy: 0,
                                iva: 0,
                                total: 0,
                                agency: 0,
                                collected: 0,
                              };
                            }

                            const add = (f, v) => {
                              totals[key][f] += parseFloat(v);
                              subtotal[f] += parseFloat(v);
                            };

                            add("net", row.revised_net_premium);
                            add("policy", row.policy_fee);
                            add("iva", row.iva);
                            add("total", row.total);
                            add("agency", row.agency_fee);
                            add(
                              "collected",
                              parseFloat(row.total) + parseFloat(row.agency_fee)
                            );

                            return (
                              <TableRow key={idx}>
                                <TableCell>{row.policy_nbr}</TableCell>
                                <TableCell
                                  style={{ textTransform: "uppercase" }}
                                >
                                  {row.client_name}
                                </TableCell>
                                <TableCell>
                                  ${formatNumber(row.revised_net_premium)}
                                </TableCell>
                                <TableCell>
                                  ${formatNumber(row.policy_fee)}
                                </TableCell>
                                <TableCell>${formatNumber(row.iva)}</TableCell>
                                <TableCell>
                                  ${formatNumber(row.total)}
                                </TableCell>
                                <TableCell>
                                  ${formatNumber(row.agency_fee)}
                                </TableCell>
                                <TableCell>
                                  $
                                  {formatNumber(
                                    parseFloat(row.total) +
                                      parseFloat(row.agency_fee)
                                  )}
                                </TableCell>
                                <TableCell>{row.payment_type_name}</TableCell>
                              </TableRow>
                            );
                          })}

                          {/* ----- SUBTOTAL DEL MÉTODO ----- */}
                          <TableRow style={{ background: "#ECFAF8" }}>
                            <TableCell></TableCell>
                            <TableCell>
                              <strong>Total {methodName} Sales:</strong>
                            </TableCell>
                            <TableCell>${formatNumber(subtotal.net)}</TableCell>
                            <TableCell>
                              ${formatNumber(subtotal.policy)}
                            </TableCell>
                            <TableCell>${formatNumber(subtotal.iva)}</TableCell>
                            <TableCell>
                              ${formatNumber(subtotal.total)}
                            </TableCell>
                            <TableCell>
                              ${formatNumber(subtotal.agency)}
                            </TableCell>
                            <TableCell>
                              ${formatNumber(subtotal.collected)}
                            </TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    })}

                    {/* ---- ESPACIO ---- */}
                    <TableRow>
                      <TableCell colSpan={9}>&nbsp;</TableCell>
                    </TableRow>

                    {/* ---- TOTALES GENERALES (fecha) ---- */}
                    {["Cash", "Check", "Credit Card", "Agent Will Charge"].map(
                      (type) => (
                        <TableRow key={type}>
                          <TableCell></TableCell>
                          <TableCell>
                            <strong>Total {type} Sales:</strong>
                          </TableCell>
                          <TableCell>
                            ${formatNumber(totals[type]?.net)}
                          </TableCell>
                          <TableCell>
                            ${formatNumber(totals[type]?.policy)}
                          </TableCell>
                          <TableCell>
                            ${formatNumber(totals[type]?.iva)}
                          </TableCell>
                          <TableCell>
                            ${formatNumber(totals[type]?.total)}
                          </TableCell>
                          <TableCell>
                            ${formatNumber(totals[type]?.agency)}
                          </TableCell>
                          <TableCell>
                            ${formatNumber(totals[type]?.collected)}
                          </TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      )
                    )}

                    {/* ---- TOTAL COLLECTED BY AGENT ---- */}
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell>
                        <strong>Total Collected by Agent:</strong>
                      </TableCell>
                      <TableCell>
                        $
                        {formatNumber(
                          (totals.Cash?.net || 0) +
                            (totals.Check?.net || 0) +
                            (totals["Agent Will Charge"]?.net || 0)
                        )}
                      </TableCell>

                      <TableCell>
                        $
                        {formatNumber(
                          (totals.Cash?.policy || 0) +
                            (totals.Check?.policy || 0) +
                            (totals["Agent Will Charge"]?.policy || 0)
                        )}
                      </TableCell>

                      <TableCell>
                        $
                        {formatNumber(
                          (totals.Cash?.iva || 0) +
                            (totals.Check?.iva || 0) +
                            (totals["Agent Will Charge"]?.iva || 0)
                        )}
                      </TableCell>

                      <TableCell>
                        $
                        {formatNumber(
                          (totals.Cash?.total || 0) +
                            (totals.Check?.total || 0) +
                            (totals["Agent Will Charge"]?.total || 0)
                        )}
                      </TableCell>

                      <TableCell>
                        $
                        {formatNumber(
                          (totals.Cash?.agency || 0) +
                            (totals.Check?.agency || 0) +
                            (totals["Agent Will Charge"]?.agency || 0)
                        )}
                      </TableCell>

                      <TableCell>
                        $
                        {formatNumber(
                          (totals.Cash?.collected || 0) +
                            (totals.Check?.collected || 0) +
                            (totals["Agent Will Charge"]?.collected || 0)
                        )}
                      </TableCell>

                      <TableCell></TableCell>
                    </TableRow>

                    {/* ---- TOTAL DAILY SALES ---- */}
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell>
                        <strong>Total Daily Sales:</strong>
                      </TableCell>

                      <TableCell>
                        $
                        {formatNumber(
                          (totals.Cash?.net || 0) +
                            (totals.Check?.net || 0) +
                            (totals["Credit Card"]?.net || 0) +
                            (totals["Agent Will Charge"]?.net || 0)
                        )}
                      </TableCell>

                      <TableCell>
                        $
                        {formatNumber(
                          (totals.Cash?.policy || 0) +
                            (totals.Check?.policy || 0) +
                            (totals["Credit Card"]?.policy || 0) +
                            (totals["Agent Will Charge"]?.policy || 0)
                        )}
                      </TableCell>

                      <TableCell>
                        $
                        {formatNumber(
                          (totals.Cash?.iva || 0) +
                            (totals.Check?.iva || 0) +
                            (totals["Credit Card"]?.iva || 0) +
                            (totals["Agent Will Charge"]?.iva || 0)
                        )}
                      </TableCell>

                      <TableCell>
                        $
                        {formatNumber(
                          (totals.Cash?.total || 0) +
                            (totals.Check?.total || 0) +
                            (totals["Credit Card"]?.total || 0) +
                            (totals["Agent Will Charge"]?.total || 0)
                        )}
                      </TableCell>

                      <TableCell>
                        $
                        {formatNumber(
                          (totals.Cash?.agency || 0) +
                            (totals.Check?.agency || 0) +
                            (totals["Credit Card"]?.agency || 0) +
                            (totals["Agent Will Charge"]?.agency || 0)
                        )}
                      </TableCell>

                      <TableCell>
                        $
                        {formatNumber(
                          (totals.Cash?.collected || 0) +
                            (totals.Check?.collected || 0) +
                            (totals["Credit Card"]?.collected || 0) +
                            (totals["Agent Will Charge"]?.collected || 0)
                        )}
                      </TableCell>

                      <TableCell></TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell colSpan={9}>&nbsp;</TableCell>
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </GridItem>

      {/* ---------------- BOTTOM BUTTONS ---------------- */}
      <GridItem xs={12} style={{ textAlign: "right", marginTop: 20 }}>
        <GridContainer style={{ marginBottom: 16 }}>
          <GridItem xs={12} sm={12} md={6}></GridItem>

          <GridItem xs={12} sm={12} md={6}>
            <GridContainer>
              <GridItem xs={12} sm={4}>
                <Button
                  type="submit"
                  variant="green"
                  startIcon={<PrintIcon />}
                  sx={{ ml: 2 }}
                  onClick={() => onGeneratePdf(5, "pdf")}
                >
                  PDF
                </Button>
              </GridItem>

              <GridItem xs={12} sm={4}>
                <Button
                  type="submit"
                  variant="green"
                  startIcon={<TableRowsIcon />}
                  sx={{ ml: 2 }}
                  onClick={() => onGenerateCsv(5, "csv")}
                >
                  CSV
                </Button>
              </GridItem>

              <GridItem xs={12} sm={4}>
                <Button
                  type="submit"
                  color="success"
                  style={{
                    backgroundColor: "#FFF",
                    borderColor: "#13816F",
                    color: "#13816F",
                    border: "1px solid",
                    width: "100%",
                  }}
                  startIcon={<ArrowBackIcon />}
                  sx={{ ml: 2 }}
                  onClick={onBack}
                >
                  Back To Reports
                </Button>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </GridItem>
    </GridContainer>
  );
}
